module.exports = __webpack_public_path__ + "img/jl-11.0fd08114.png";